import { useSelector } from 'react-redux'

export default function useCombinedPremiumAdData(campaignId) {
  // TODO not have to repeat this garbage whenever trying to access data in
  // the store.
  const campaign = useSelector(
    (state) =>
      state.ad && state.ad.paidAdsById && state.ad.paidAdsById[campaignId],
  )

  // const channelCampaignId = campaign?.campaign_channels?.[0]?.id
  const campaignChannelId =
    campaign && campaign.campaign_channels && campaign.campaign_channels.length
      ? campaign.campaign_channels[0].id
      : null

  // TODO Frontend seems to randomly swap these two words.
  const channelCampaign = useSelector(
    (state) =>
      state.facebookAds &&
      state.facebookAds.channelCampaigns &&
      state.facebookAds.channelCampaigns[campaignChannelId],
  )

  // const adCreativeTemplate = channelCampaign?.adcreative_templates?.[0]
  const adCreativeTemplate =
    channelCampaign &&
    channelCampaign.adcreative_templates &&
    channelCampaign.adcreative_templates.length
      ? channelCampaign.adcreative_templates[0]
      : null

  // const adSetTemplate = channelCampaign?.ad_set_templates?.[0]
  const adSetTemplate =
    channelCampaign &&
    channelCampaign.ad_set_templates &&
    channelCampaign.ad_set_templates.length
      ? channelCampaign.ad_set_templates[0]
      : null

  return {
    campaign,
    campaignChannelId,
    channelCampaign,
    /** Easy access to `channelCampaign.adcreative_templates[0]` */
    adCreativeTemplate,
    /** Easy access to `channelCampaign.ad_set_templates[0]` */
    adSetTemplate,
  }
}
